import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function GuestOnly({ children }) {
  const { isAuth, authLoading } = useAuth();

  if (authLoading) return null;

  if (isAuth) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}